import { render, staticRenderFns } from "./messageTableHead.vue?vue&type=template&id=4f31a8d0&scoped=true&"
import script from "./messageTableHead.vue?vue&type=script&lang=js&"
export * from "./messageTableHead.vue?vue&type=script&lang=js&"
import style0 from "./messageTableHead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./messageTableHead.vue?vue&type=style&index=1&id=4f31a8d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31a8d0",
  null
  
)

export default component.exports